import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserAddContainerActions'

const initialState = {
  submitAdviser: false,
  submittingAdviser: false,
  submittedAdviser: false,

  adviser: {
    ifaCode: '',
    firstName: '',
    middleName: '',
    lastName: ''
  },

  isInvalid: {
    formIsValid: false,

    ifaCode: {
      valid: false,
      message: null,
      validationstate: null
    },

    firstName: {
      valid: false,
      message: null,
      validationstate: null
    },

    lastName: {
      valid: false,
      message: null,
      validationstate: null
    }
  }
}

export default (state = initialState, action) => {
  const newState = cloneDeep(state)
  const { setting, submit, submitting, submitted } = events

  switch (action.type) {

    case setting.ifaCode:
      newState.adviser.ifaCode = action.payload

      newState.isInvalid.ifaCode = {
        valid: !!action.payload,
        message: action.payload ? null : 'Required',
        validationstate: null
      }

      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState

    case setting.firstName:
      newState.adviser.firstName = action.payload

      newState.isInvalid.firstName = {
        valid: !!action.payload,
        message: action.payload ? null : 'Required',
        validationstate: null
      }

      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState


    case setting.lastName:
      newState.adviser.lastName = action.payload

      newState.isInvalid.lastName = {
        valid: !!action.payload,
        message: action.payload ? null : 'Required',
        validationstate: null
      }

      newState.isInvalid.formIsValid = isFormValid(newState)
      return newState

    case setting.middleName:
      newState.adviser.middleName = action.payload
      return newState

    case submit.adviser:
      newState.submittedAdviser = false
      newState.submitAdviser = true
      return newState

    case submitting.adviser:
      newState.submitAdviser = false
      newState.submittingAdviser = true
      return newState

    case submitted.adviser:
      newState.submittingAdviser = false
      newState.submittedAdviser = true

      newState.adviser = cloneDeep(initialState.adviser)
      newState.isInvalid = cloneDeep(initialState.isInvalid)

      return newState

    default:
      return state
  }
}

const isFormValid = (state) => {
  const v = state.isInvalid

  return (
    v.ifaCode.valid &&
    v.firstName.valid &&
    v.lastName.valid
  )
}